import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import client from "../api";
import { useAuth } from "../auth";
import { useI18n, formatApiErrorDetail } from "../i18n";
import Logo from "../components/Logo";
import { ShieldCheck } from "lucide-react";

export default function SuperAdminLogin() {
  const { t } = useI18n();
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try {
      const { data } = await client.post("/auth/admin-login", { email, password });
      loginWithToken(data.token, data.user);
      navigate("/super-admin", { replace: true });
    } catch (e) {
      setErr(formatApiErrorDetail(e?.response?.data?.detail) || t.auth.errorGeneric);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-deep flex items-center justify-center px-6">
      <div className="max-w-sm w-full" data-testid="sa-login-page">
        <div className="flex justify-center mb-6">
          <Logo size="lg" />
        </div>
        <div className="text-center mb-6">
          <div className="chip chip-yellow inline-flex">RENOVA · SA</div>
          <h1 className="font-heading text-2xl tracking-tight mt-3">{t.auth.saTitle}</h1>
          <p className="text-zinc-400 mt-1 text-sm">{t.auth.saSub}</p>
        </div>
        <form onSubmit={submit} className="card-neon p-6 space-y-4 glow-yellow">
          <div>
            <label className="input-label">{t.auth.email}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="input-neon"
              data-testid="sa-email"
              placeholder="renova360@renova360.it"
            />
          </div>
          <div>
            <label className="input-label">{t.auth.password}</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="input-neon"
              data-testid="sa-password"
            />
          </div>
          {err && <div className="text-xs text-red-400 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2" data-testid="sa-error">{err}</div>}
          <button type="submit" disabled={loading} className="btn-yellow w-full justify-center" data-testid="sa-submit">
            {loading ? t.auth.processing : t.auth.submitSa}
          </button>
          <Link to="/" className="block text-center text-xs text-zinc-500 hover:text-neon-cyan transition" data-testid="sa-back">{t.auth.back}</Link>
        </form>
      </div>
    </div>
  );
}
